import { Injectable } from '@angular/core';
import { GET_OFFER_CALCULATION_TRACE } from '@queries/product-offers-graphql';
import { GET_PROPOSAL_LINE_CALCULATION_TRACE } from '@queries/proposals.graphql';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { CalculationTrace } from './calculation-trace.types';

/**
 * Admin only audit trail of every calculated number (D18). The backend rejects other roles, and the UI only
 * mounts the panel for admins. Nothing is cached: a trace must always reflect the current data.
 */
@Injectable({
  providedIn: 'root',
})
export class CalculationTraceService {
  constructor(private apollo: Apollo) {}

  getLineTrace(lineId: number): Observable<CalculationTrace> {
    return this.apollo
      .query<{ ProposalLineCalculationTrace: CalculationTrace }>({
        query: GET_PROPOSAL_LINE_CALCULATION_TRACE,
        variables: { lineId: +lineId },
        fetchPolicy: 'no-cache',
      })
      .pipe(map(({ data }) => data.ProposalLineCalculationTrace));
  }

  getOfferTrace(offerId: number): Observable<CalculationTrace> {
    return this.apollo
      .query<{ ProductOfferCalculationTrace: CalculationTrace }>({
        query: GET_OFFER_CALCULATION_TRACE,
        variables: { offerId: +offerId },
        fetchPolicy: 'no-cache',
      })
      .pipe(map(({ data }) => data.ProductOfferCalculationTrace));
  }
}
